export const ARTICLES_PER_PAGE = 6;
export const CAN_SEE_COUNTS = 33;
export const GST_NUMBER_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]{2}[0-9A-Z]$/;